import { AutorenewOutlined, CheckCircleOutlined, CloseOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import React from 'react';

export const Ga4ButtonDefault = ({ onClick }: { onClick: () => void }) => (
  <Button variant="text" startIcon={<AutorenewOutlined />} onClick={onClick}>
    verbindung prüfen
  </Button>
);

export const Ga4ButtonSuccess = () => (
  <Button
    variant="text"
    startIcon={<CheckCircleOutlined sx={{ color: 'success.dark' }} />}
    sx={{ color: 'success.dark' }}
  >
    Verbindung OK
  </Button>
);

export const Ga4ButtonError = () => (
  <Button
    variant="text"
    startIcon={<CloseOutlined sx={{ color: 'error.dark' }} />}
    sx={{ color: 'error.dark', minWidth: 45 }}
  >
    Verbindung fehlgeschlagen
  </Button>
);
